import { AlertTriangle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';

export function LegacyFlagWarningIcon() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-help items-center">
          <AlertTriangle className="h-3.5 w-3.5 text-amber-600" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        This flag appears in AppConfig but is not declared in{' '}
        <code className="text-xs">AppConfigFeatureFlagKey</code>. It may be a pending type
        reconciliation or a flag removed from code that still lives in AppConfig.
      </TooltipContent>
    </Tooltip>
  );
}
